if (!customElements.get('primary-carousel')) {
  class PrimaryCarousel extends HTMLElement {
    constructor() {
      super();
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      this.scroller = this.querySelector('[data-primary-scroller]');
      this.previousButton = this.querySelector('[data-primary-previous]');
      this.nextButton = this.querySelector('[data-primary-next]');

      if (!this.scroller) return;

      this.previousButton?.addEventListener('click', () => this.move(-1));
      this.nextButton?.addEventListener('click', () => this.move(1));
      this.scroller.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize, { passive: true });
      this.updateControls();
    }

    disconnectedCallback() {
      this.scroller?.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
    }

    move(direction) {
      const item = this.scroller.querySelector('[data-primary-slide]');
      if (!item) return;

      const styles = window.getComputedStyle(this.scroller);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      const distance = item.getBoundingClientRect().width + gap;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.scroller.scrollBy({
        left: distance * direction,
        behavior: reduceMotion ? 'auto' : 'smooth',
      });
    }

    handleScroll() {
      window.requestAnimationFrame(() => this.updateControls());
    }

    handleResize() {
      this.updateControls();
    }

    updateControls() {
      if (!this.scroller) return;

      const maximum = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
      const position = Math.abs(this.scroller.scrollLeft);
      const hasOverflow = maximum > 2;

      if (this.previousButton) {
        this.previousButton.disabled = !hasOverflow || position <= 2;
      }

      if (this.nextButton) {
        this.nextButton.disabled = !hasOverflow || position >= maximum - 2;
      }
    }
  }

  customElements.define('primary-carousel', PrimaryCarousel);
}
